'use client';

import { observer } from 'mobx-react-lite';

import * as styles from './SearchResultInfo.css';

type SearchResultInfoProps = {
  pageTypeText: string;
  numberOfEvents: number;
};

function SearchResultInfo({
  pageTypeText,
  numberOfEvents
}: SearchResultInfoProps) {
  if (numberOfEvents === 0) return null;

  const foundText = numberOfEvents > 1 ? 'encontrados' : 'encontrado';

  return (
    <div className={styles.Subtitle} data-testid="search-result-info">
      <span>{`${numberOfEvents} ${pageTypeText} ${foundText}`}</span>
    </div>
  );
}

export default observer(SearchResultInfo);
